import React from 'react';
import styles from './SessionTimeoutOverlay.css';

interface SessionTimeoutOverlayProps {
    timeLeft: string;
}

const SessionTimeoutOverlay = ({timeLeft}: SessionTimeoutOverlayProps) => (
    <span className={styles.SessionTimeoutOverlay}>
        The system will logout in <time className={styles.timeLeft}>{timeLeft}</time>.
    </span>
);

export default SessionTimeoutOverlay;
